/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestsnotonrequest3Inputs */

const en_requestsnotonrequest3 = /** @type {(inputs: Requestsnotonrequest3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This event is not on request. Set its visibility to "On request" so people can ask to join.`)
};

const de_requestsnotonrequest3 = /** @type {(inputs: Requestsnotonrequest3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Event ist nicht auf Anfrage. Stell die Sichtbarkeit auf „Auf Anfrage“, damit Leute anfragen können.`)
};

/**
* | output |
* | --- |
* | "This event is not on request. Set its visibility to \"On request\" so people can ask to join." |
*
* @param {Requestsnotonrequest3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestsnotonrequest3 = /** @type {((inputs?: Requestsnotonrequest3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestsnotonrequest3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestsnotonrequest3(inputs)
	return de_requestsnotonrequest3(inputs)
});
export { requestsnotonrequest3 as "requestsNotOnRequest" }